export class ActionsSharedData {
    public totalCount: string;
    public isMantenimientoCsite: boolean;
}
